// extracted by mini-css-extract-plugin
export default {"error":"FetchLineItemsError_error__F-ziP h4"};